<template>
  <div class="container">
    <div class="row">
      <VslBoosterTreinamento :modulos-conteudos="modulosConteudos" />
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import VslBoosterTreinamento from '@/views/App/Treinamentos/Vsl-Booster/VslBoosterTreinamento.vue'

import { ModuloService } from '@/services/Modulo'

const moduloService = new ModuloService()

export default {
  components: {
    VslBoosterTreinamento,
    BRow,
    BCol,

  },
  data() {
    return {
      modulosConteudos: {},
    }
  },
  computed: {
    idUser() {
      return JSON.parse(localStorage.getItem('userData')).id
    },
  },
  beforeMount() {
    this.modulosConteudos = {}
  },
  mounted() {
    this.getModulos()
  },
  methods: {
    async getModulos() {
      await moduloService.getModuloConteudoById(144).then(response => {
        console.log(response.type_modulo === 'vsl_booster')
        if (response.type_modulo === 'vsl_booster') {
          this.modulosConteudos = response
        }
      })
    },
  },
}
</script>
